<template>
  <Modal :mask-closable="false" :title="title" :width="800" v-model="visible" @on-cancel="handleCancel" :destroyOnClose="true">
    <div class="student_detail">
      <Form ref="studentInfo" :label-width="150" :rules="studentInfo" :model="params" class="form1">
        <Row>
          <Col :md="12" :sm="24">
            <FormItem label="姓名:" prop="name">
              <Input v-if="isEdit" v-model="params.name" placeholder="请输入"></Input>
              <span v-else>{{ params.name }}</span>
            </FormItem>
          </Col>
          <Col :md="12" :sm="24">
            <FormItem label="国籍:" prop="nationality">
              <j-dict-select-tag
                v-if="isEdit"
                v-model="params.nationality"
                defaultName="全部"
                :hasAll="false"
                :filterable="true"
                :triggerChange="true"
                @on-change="change('nationality', $event)"
                placeholder="请选择"
                dictCode="talentNationality"
              />
              <span v-else>{{ params.nationality }}</span>
            </FormItem>
          </Col>
          <Col :md="12" :sm="24">
            <FormItem label="证件类型:" prop="idType">
              <Select v-if="isEdit" clearable placeholder="请选择" @change="change('idType', $event)" v-model="params.idType">
                <Option value="身份证">身份证</Option>
                <Option value="护照">护照</Option>
              </Select>
              <span v-else>{{ params.idType }}</span>
            </FormItem>
          </Col>
          <Col :md="12" :sm="24">
            <FormItem label="证件号码:" prop="idNum">
              <Input v-if="isEdit" @on-blur="checkCode" v-model="params.idNum" placeholder="请输入"></Input>
              <span v-else>{{ params.idNum }}</span>
            </FormItem>
          </Col>
          <Col :md="12" :sm="24">
            <FormItem label="性别:" prop="sex">
              <Select v-if="isEdit" clearable placeholder="请选择" v-model="params.sex">
                <Option :value="1">男</Option>
                <Option :value="2">女</Option>
              </Select>
              <span v-else>{{ params.sex === 1 ? '男' : '女' }}</span>
            </FormItem>
          </Col>
          <Col :md="12" :sm="24">
            <FormItem label="出生日期:" prop="birth">
              <DatePicker
                v-if="isEdit"
                placeholder="请选择"
                :value="params.birth"
                type="date"
                format="yyyy-MM-dd"
                @on-change="dataChange('birth', $event)"
              />
              <span v-else>{{ params.birth }}</span>
            </FormItem>
          </Col>
          <Col :md="12" :sm="24">
            <FormItem label="年龄:" prop="age">
              <Input v-if="isEdit" v-model="params.age" placeholder="请输入"></Input>
              <span v-else>{{ params.age }}</span>
            </FormItem>
          </Col>
          <Col :md="12" :sm="24">
            <FormItem label="联系方式:" prop="contactInfo">
              <Input v-if="isEdit" v-model="params.contactInfo" placeholder="请输入"></Input>
              <span v-else>{{ params.contactInfo }}</span>
            </FormItem>
          </Col>
          <Col :md="12" :sm="24">
            <FormItem label="所属区域:" prop="area">
              <j-dict-select-tag
                v-if="isEdit"
                defaultName="全部"
                v-model="params.area"
                :hasAll="false"
                :filterable="true"
                :triggerChange="true"
                @on-change="change('area', $event)"
                placeholder="请选择所属区域"
                dictCode="areacode"
              />
              <span v-else>{{ params.area }}</span>
            </FormItem>
          </Col>
          <Col :md="12" :sm="24">
            <FormItem label="毕业院校:" prop="schoolName">
              <Input v-if="isEdit" v-model="params.schoolName" placeholder="请输入"></Input>
              <span v-else>{{ params.schoolName }}</span>
            </FormItem>
          </Col>
          <Col :md="12" :sm="24">
            <FormItem label="在职状态:" prop="jobStatus">
              <j-dict-select-tag
                v-if="isEdit"
                defaultName="全部"
                v-model="params.jobStatus"
                :hasAll="false"
                :triggerChange="true"
                @on-change="change('jobStatus', $event)"
                placeholder="请选择在职状态"
                dictCode="job_status"
              />
              <span v-else>{{ params.jobStatus }}</span>
            </FormItem>
          </Col>
          <Col :md="12" :sm="24">
            <FormItem label="学历:" prop="education">
              <j-dict-select-tag
                v-if="isEdit"
                defaultName="全部"
                v-model="params.education"
                :hasAll="false"
                :filterable="true"
                :triggerChange="true"
                @on-change="change('education', $event)"
                placeholder="请选择学历"
                dictCode="TalentQualification"
              />
              <span v-else>{{ params.education }}</span>
            </FormItem>
          </Col>
          <Col :md="12" :sm="24">
            <FormItem label="所属单位:" prop="workplace">
              <Input v-if="isEdit" v-model="params.workplace" placeholder="请输入"></Input>
              <span v-else>{{ params.workplace }}</span>
            </FormItem>
          </Col>
          <Col :md="12" :sm="24">
            <FormItem label="所学专业:">
              <j-dict-select-tag
                v-if="isEdit"
                v-model="params.major"
                defaultName="全部"
                :triggerChange="true"
                :hasAll="false"
                :filterable="true"
                placeholder="请选择"
                dictCode="talentEduMajorSubjectA"
                @on-change="change('major', $event)"
              />
              <span v-else>{{ params.major }}</span>
            </FormItem>
          </Col>
          <Col :md="12" :sm="24">
            <FormItem label="来台工作时间:" prop="comeTzTime">
              <DatePicker
                v-if="isEdit"
                placeholder="请选择"
                :value="params.comeTzTime"
                class="time-pick"
                type="date"
                format="yyyy-MM-dd"
                @on-change="dataChange('comeTzTime', $event)"
              />
              <span v-else>{{ params.comeTzTime }}</span>
            </FormItem>
          </Col>
          <Col :md="12" :sm="24">
            <FormItem label="毕业时间:" prop="graduationTime">
              <DatePicker
                v-if="isEdit"
                placeholder="请选择"
                :value="params.graduationTime"
                class="time-pick"
                type="date"
                format="yyyy-MM-dd"
                @on-change="dataChange('graduationTime', $event)"
              />
              <span v-else>{{ params.graduationTime }}</span>
            </FormItem>
          </Col>
          <Col :md="12" :sm="24">
            <FormItem label="在台首次缴纳社保时间:" prop="socialInsuranceStart">
              <DatePicker
                v-if="isEdit"
                placeholder="请选择"
                :value="params.socialInsuranceStart"
                class="time-pick"
                type="date"
                format="yyyy-MM-dd"
                @on-change="dataChange('socialInsuranceStart', $event)"
              />
              <span v-else>{{ params.socialInsuranceStart }}</span>
            </FormItem>
          </Col>
        </Row>
      </Form>
    </div>
    <template v-if="isEdit" slot="footer">
      <Button type="primary" @click="handleOk">提交</Button>
      <Button @click="handleCancel">取消</Button>
    </template>
    <template v-else slot="footer">
      <span></span>
    </template>
  </Modal>
</template>
<script>
import JDictSelectTag from '@/components/JDictSelectTag'

import applyApi from '@/api/apply'

import { validateIdCard } from '@/utils/validate'

export default {
  name: 'educationModal',
  components: { JDictSelectTag },
  data() {
    return {
      visible: false,
      title: '',
      id: '',
      isEdit: false,
      params: {},
      companyName: '',
      studentInfo: {
        name: [{ required: true, message: '请输入' }],
        nationality: [{ required: true, message: '请选择' }],
        idType: [{ required: true, message: '请选择' }],
        idNum: [{ required: true, message: '请输入' }],
        age: [{ required: true, message: '请输入' }],
        area: [{ required: true, message: '请选择' }],
        schoolName: [{ required: true, message: '请输入' }],
        contactInfo: [{ required: true, message: '请输入' }],
        education: [{ required: true, message: '请选择' }],
        workplace: [{ required: true, message: '请输入' }],
        comeTzTime: [{ required: true, message: '请选择' }],
        graduationTime: [{ required: true, message: '请选择' }],
        socialInsuranceStart: [{ required: true, message: '请选择' }]
      }
    }
  },
  watch: {
    'params.idType': function idType() {
      this.handleIdNum()
    },
    'params.name': function name() {
      this.handleIdNum()
    }
  },
  methods: {
    async showFun(id, type, name) {
      this.visible = true
      this.id = id
      const userInfo = window.localStorage.getItem('userInfo')
      if (userInfo) {
        this.companyName = JSON.parse(userInfo).companyName
      }
      if (type === 'add') {
        this.isEdit = true
        this.title = '新增大学生信息'
        this.params = {}
        this.params.workplace = this.companyName
      } else {
        if (type === 'detail') {
          this.isEdit = false
          this.title = `大学生信息详情-${name}`
          this.studentInfo = {}
        } else {
          this.isEdit = true
          this.title = `编辑大学生信息-${name}`
        }
        const res = await applyApi.getCollegeInfo({ id })
        this.params = res.success && res.result ? res.result : {}
      }
    },
    handleCancel() {
      this.visible = false
      this.$refs.studentInfo.resetFields()
    },
    async handleOk() {
      const result1 = await this.$refs.studentInfo.validate()
      if (this.params.idType === '身份证') {
        const value = this.params.idNum
        if (!validateIdCard(value)) {
          this.$Message.info('请输入正确格式的身份证号')
          return
        }
      }
      if (result1) {
        if (this.title.indexOf('编辑') > -1) {
          applyApi.editCollegeInfo({ ...this.params }).then((res) => {
            if (res.success) {
              this.$Message.success('修改成功')
              this.$emit('handleOk')
            }
          })
        } else {
          applyApi.addCollegeInfo({ ...this.params }).then((res) => {
            if (res.success) {
              this.$Message.success('添加成功')
              this.$emit('handleOk')
            }
          })
        }
        this.visible = false
      } else {
        this.$Message.info('完成所有必选项!')
      }
    },
    checkCode() {
      this.handleIdNum()
    },
    handleIdNum() {
      const value = this.params.idNum
      if (!value) return
      const newDate = new Date()
      const nowYear = newDate.getFullYear(newDate)
      if (validateIdCard(value)) {
        const birthday = value.slice(6, 14)
        const sex = parseInt(value.slice(-2, -1), 10) % 2 === 1 ? 1 : 2
        this.$set(this.params, 'sex', sex)
        this.$set(this.params, 'age', nowYear - birthday.slice(0, 4))
        this.$set(this.params, 'birth', `${birthday.slice(0, 4)}-${birthday.slice(4, 6)}-${birthday.slice(6)}`)
        if (this.params.name) {
          applyApi.getSocialInfo({ name: this.params.name, idCard: this.params.idNum, callModule: '人才项目-大学生报送审核' }).then((res) => {
            if (res.success) {
              this.$set(this.params, 'socialInsuranceStart', res.result.startDate)
            }
          })
          applyApi.getEducationInfo({ name: this.params.name, idCard: this.params.idNum, callModule: '人才项目-大学生报送审核' }).then((res) => {
            if (res.success) {
              this.$set(this.params, 'schoolName', res.result.school)
              this.$set(this.params, 'education', res.result.education)
              this.$set(this.params, 'major', res.result.major)
              this.$set(this.params, 'graduationTime', res.result.graduationDate)
            }
          })
        }
      } else {
        this.$Message.info('请输入正确格式的身份证号')
      }
    },
    chooseCardType(e) {
      this.$set(this.params, 'idType', e)
    },
    change(type, e) {
      this.$set(this.params, type, e)
    },
    dataChange(key, val) {
      this.$set(this.params, key, val)
    }
  }
}
</script>
<style lang="less">
.student_detail {
  padding: 0 40px;
  .ivu-col {
    height: 3.6rem;
  }
  .ivu-form-item {
    display: flex;
    margin-bottom: 10px;
  }
  .ivu-form-item-content {
    flex: 1;
    margin-left: 0 !important;
    display: flex;
    & > div:first-child {
      flex: 1;
    }
    .ivu-form-item-error-tip {
      position: relative;
      top: 0;
      left: 0;
      margin-left: 20px;
      line-height: 33px;
    }
  }

  .date_pick {
    & > .ivu-form-item-content {
      & > div {
        flex: 1;
        margin-right: 20px;
      }
    }
  }
  .title {
    display: inline-block;
    font-weight: 700;
    font-size: 16px;
    padding-bottom: 20px;
  }
}
</style>
